import Vue from 'vue'
import ReferredTab from './ReferredTab/ReferredTab.vue'
import SummaryCard from './SummaryCard/SummaryCard.vue'
import WithdrawTab from './WithdrawTab/WithdrawTab.vue'
import { CURRENCY_FIELD_NAME } from '@/constants/currency'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import BonusesCard from '@/partials/BonusesCard/BonusesCard.vue'
import { getCurrency } from '@/utils-ts/currencies'

export default Vue.extend<any, any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    BonusesCard,
    ReferredTab,
    SummaryCard,
    WithdrawTab,
  },
  data() {
    return {
      activeTab: 0,
      currency: getCurrency({ value: 'TIME', field: CURRENCY_FIELD_NAME }),
    }
  },
  methods: {
    onWithdrawRequested() {
      this.activeTab = 1
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('Referrals'),
    }
  },
})
